import { render, staticRenderFns } from "./WorkplaceCrudModal.vue?vue&type=template&id=f4832334&"
import script from "./WorkplaceCrudModal.vue?vue&type=script&lang=js&"
export * from "./WorkplaceCrudModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports